/**
 * 媒体相关
 */
import services from '../../services'
import devConfig from '@/config/index'
import { __replaceDotCom } from '@/utils/tools'
let hostUrl = devConfig.gateway.MsaGatewayAddress
hostUrl = __replaceDotCom(hostUrl, true)
const state = {
    idCardTypeLookup: [], // 证件类型lookup
    applicationStatusLookup: [], // 申请单状态lookup
    organizationList: [], // 当前登录人拥有的组织列表
    downloadTemplateUrl: `${hostUrl}com.huawei.it.mbs.eventsgo:eventsgomedia/eventsgo/media/servlet/download?dlType=personTemplateDownload` // 下载导入模板的地址
}
/** lookup配置 */
const lookupCfg = {
    // 获取证件类型lookup
    ID_CARD_TYPE: {
        mut: 'setIdCardTypeLookup',
        list: 'idCardTypeLookup'
    },
    // 获取申请单状态lookup
    FROM_STATUS: {
        mut: 'setApplicationStatusLookup',
        list: 'applicationStatusLookup'
    }
}
const actions = {

    /** lookup查询 */
    getLookUpData(context, param) {
        let { state, commit } = context
        // 匹配
        let item = lookupCfg[param.classifyCode]
        return new Promise((resolve, reject) => {
            // 如果已有数据则不重新请求
            if (state[item.list].length) return
            // 暂无申请单状态lookup, 先用人员状态lookup
            param.appName = 'eventsgomedia' // 增加参数
            services.commonSer.getLookUpData(param).then((res) => {
                let data = res.data && res.data.data || []
                commit(item.mut, data)
                resolve(data)
            })
        })
    },

    /**
     * 获取人员详情页面组织列表
     * @param {*} context
     * @param {*} param
     */
    getOrganizationListAct(context, param) {
        return new Promise((resolve, reject) => {
            services.mediaSer.getOrganizationListSer(param).then((res) => {
                resolve(res.data || {})
            })
        })
    },

    /** ==================申请单相关接口===================== */
    /**
     * 获取申请单列表
     * @param {*} context
     * @param {*} param
     */
    getApplicationManagementListAct(context, param) {
        return new Promise((resolve, reject) => {
            services.mediaSer.getApplicationManagementListSer(param).then((res) => {
                resolve(res.data || {})
            })
        })
    },

    /** 获取接口人W3账号 */
    findOrgCfgUserList(context, param) {
        return new Promise((resolve, reject) => {
            services.mediaSer.findOrgCfgUserList(param).then((res) => {
                resolve(res.data || {})
            })
        })
    }
}

const mutations = {

    /**
     * 设置获取资源预订时间lookup
     * @param {} state
     * @param {*} payload
     */
    setIdCardTypeLookup(state, payload) {
        state.idCardTypeLookup = payload
    },

    /**
     * 设置组织列表
     * @param {} state
     * @param {*} payload
     */
    setOrganizationList(state, payload) {
        state.organizationList = payload
    },

    /**
     * 设置申请单状态lookup
     * @param {} state
     * @param {*} payload
     */
    setApplicationStatusLookup(state, payload) {
        state.applicationStatusLookup = payload
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
